import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsMaintenanceJob, PmsMaintenanceJob } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsMaintenanceJob>
    useData={usePmsMaintenanceJob}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
